import type { ReactNode } from "react";
import informationImage from "assets/images/cologuard/information.svg";
import eligibilityImage from "assets/images/cologuard/eligibility.svg";
import insuranceImage from "assets/images/cologuard/insurance.svg";
import sampleImage from "assets/images/cologuard/sample.svg";
import actionImage from "assets/images/cologuard/action.svg";

export const NAVIGATION_EMAIL = "navigation@genomiclife.com";
export const NAVIGATION_MAILTO = `mailto:${NAVIGATION_EMAIL}`;
export const NAVIGATION_PHONE_DISPLAY = "844-694-3666";
export const NAVIGATION_PHONE_TEL = "tel:+18446943666";

export const COLOGUARD_WEBSITE_URL =
  "https://www.exactsciences.com/request-products/cologuard?utm_source=genomic_life&utm_medium=outlink_cta&utm_campaign=cg_ptoss_cologuard_genomic_life_q326";
export const COLOGUARD_TEST_ID = "exact-sciences-cologuard";
export const COLOGUARD_VIDEO_URL =
  "https://cdn.genomiclife.com/videos/CCSVID3-Short-R1-0.mp4";

export type HowItWorksStep = {
  key: string;
  title: string;
  body: string;
  image: string;
};

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    key: "information",
    title: "Step 1: Share provider information",
    body: "We’ll ask for your provider’s contact information so that we can help make sure your doctor gets your results. That’s important because Cologuard can be life-saving—but only if you and your doctor take action based on the results.",
    image: informationImage
  },
  {
    key: "eligibility",
    title: "Step 2: Confirm eligibility",
    body: "Visit the Cologuard website and answer a few more questions to confirm your eligibility.",
    image: eligibilityImage
  },
  {
    key: "insurance",
    title: "Step 3: Provide insurance",
    body: "Cologuard will be billed to your insurance, so have your insurance information on hand.",
    image: insuranceImage
  },
  {
    key: "sample",
    title: "Step 4: Submit sample",
    body: "You will receive a stool collection kit in the mail. Provide your sample and mail it to the Cologuard lab.",
    image: sampleImage
  },
  {
    key: "action",
    title: "Step 5: Get your results & take action",
    body: "Results are typically ready in 8 to 10 days. You will be able to access them via the Cologuard website.\n\nBe sure to share your results with your healthcare provider. The Genomic Life navigation team can also help with next steps.",
    image: actionImage
  }
];

export type FaqItem = {
  question: string;
  answer: ReactNode;
};
